import * as Sentry from '@sentry/solid';

/**
 * Sentry browser SDK init + shared capture helpers. Mirrors the shape
 * of `apps/web/sentry.client.config.ts` + `apps/web/lib/sentry/index.ts`
 * so any future shared code stays consistent across apps.
 *
 * The DSN and environment come from runtime config injected via the
 * `getPublicConfig` server function in `src/routes/__root.tsx`, not
 * build-time env vars — matching how `initPostHog` works.
 */

let initialized = false;

export function initSentry(dsn: string, environment: string): void {
    if (initialized || typeof window === 'undefined' || !dsn) return;
    Sentry.init({
        dsn,
        environment,
        // Enabled on every built bundle (dev/qa/prod Cloud Run). Only
        // disabled during `vite dev` locally, where `import.meta.env.DEV`
        // is the build-time true flag.
        enabled: !import.meta.env.DEV,
        tracesSampleRate: 0,
        debug: false
    });
    initialized = true;
}

export function captureException(error: unknown): void {
    Sentry.captureException(error);
}

export function captureMessage(
    message: string,
    level?: Sentry.SeverityLevel
): void {
    Sentry.captureMessage(message, level);
}
